import React, { useEffect, useState } from 'react';
import { consumerAlgorithmCalculation } from '../../../redux/actions/Firebase';
import ReportLayout from '../../../myComponents/report/ReportLayout';
import ChartCalculations from '../Consumer/chartCalculations';
import { DEFAULT_BATCH_COUNTRY } from '../../../config/batchConfig';
import axios from '../../../API/axiosConfig';
import { combineCustomAndRegularBatchDataCodes, findLatestExistingBatchData } from '../../../helperFunctions';

const ConsumerReport = () => {
  const [state, setState] = useState({ ready: false, result: null, meta: [], error: '' });

  useEffect(() => {
    const run = async () => {
      try {
        const { data } = await axios.get('/fs/data');
        const appData = data.result;
        const normalizedAppData = {
          ...appData,
          combinedBatchDataCodes:
            appData?.combinedBatchDataCodes ||
            combineCustomAndRegularBatchDataCodes(appData?.existingBatchData || {}, appData?.customBatchData || {}),
          socialMediaPosts: appData?.socialMediaPosts || appData?.socialPosts || [],
        };
        const availableBatchCountries = Object.keys(normalizedAppData?.combinedBatchDataCodes || {});
        const resolvedBatchCountry =
          normalizedAppData?.combinedBatchDataCodes?.[DEFAULT_BATCH_COUNTRY] ? DEFAULT_BATCH_COUNTRY : availableBatchCountries[0];

        if (!resolvedBatchCountry || !normalizedAppData?.combinedBatchDataCodes?.[resolvedBatchCountry]) {
          throw new Error('No batch data available for export.');
        }

        const { latestQuarter, latestYear } = findLatestExistingBatchData(normalizedAppData.combinedBatchDataCodes[resolvedBatchCountry]);
        const batch = { quarter: [latestQuarter], year: latestYear };
        const result = await consumerAlgorithmCalculation({ filters: null, batches: batch, batchCountry: resolvedBatchCountry });
        setState({
          ready: true,
          result,
          error: '',
          meta: [
            { label: 'Dataset', value: `${latestQuarter} ${latestYear} (${resolvedBatchCountry})` },
            { label: 'Generated', value: new Date().toLocaleString() },
            { label: 'Batch Country', value: resolvedBatchCountry },
          ],
        });
      } catch (error) {
        setState({
          ready: true,
          result: null,
          error: error?.message || 'Failed to prepare report data.',
          meta: [{ label: 'Generated', value: new Date().toLocaleString() }],
        });
      }
    };
    run();
  }, []);

  return <ReportLayout title="Consumer Dashboard Report" metadata={state.meta} ready={state.ready} hasError={!!state.error} errorMessage={state.error}>{state.result && <ChartCalculations data={state.result} />}{!state.result && state.error && <p>{state.error}</p>}</ReportLayout>;
};

export default ConsumerReport;
